<app-multiselect-tags #funcExp class="w-100" [showTagClose]="true" #multiselectElement
    [filedName]="label" [autoCompleteList]="dataSource" (onType)="typeHandle($event)"
    [selectedItems]="selectedValues" (onSelect)="selectItem($event)"></app-multiselect-tags>
